export const addToGoogleDataLayer = (virtualPageURL, virtualPageTitle, virtualLanguage, addressTypeChange = {}) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'Virtual Page View',
      virtualPageURL: virtualPageURL,
      virtualPageTitle: virtualPageTitle,
      virtualLanguage: virtualLanguage,
      ...addressTypeChange
    })
  }
}
